import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

const isObject = (param) => typeof param === 'object';
const calcPaginas = (total, quantidade) => Math.ceil(total / quantidade);

// A quantidade de paginas entre o link ativo (atual)
// Exemplo: 1 2 3 [4] 5 6 7
const LIMITE_ITENS_ATUAL = 3;

@Component({
  selector: 'paginacao',
  templateUrl: './paginacao.component.html',
  styleUrls: ['./paginacao.component.scss'],
})
export class PaginacaoComponent implements OnInit {

  @Input() configuracao: Observable<any>;
  @Output() callback: EventEmitter<any> = new EventEmitter();

  paginas = [];
  private atual;

  constructor() { }

  ngOnInit() {

    if (!isObject(this.configuracao)) {
      return;
    }

    this.configuracao.subscribe((data) => {
      this.paginas = [];

      const numeroPaginas = calcPaginas(data.total, data.porPagina);
      this.atual = Number(data.atual);


      for (let i = 0; i < numeroPaginas; i++) {
        const pagina = i + 1;

        this.paginas.push({
          pagina,
          active: pagina === this.atual,
        });
      }
    });
  }

  indiceUltimaPagina() {
    return this.paginas.length - 1;
  }

  indiceAtivo() {
    for (let i = 0; i < this.paginas.length; i++) {
      if (this.paginas[i].active) {
        return i;
      }
    }
  }

  isAtivo(indice) {
    return this.paginas[indice].active;
  }

  isUltimoAtivo() {
    return this.isAtivo(this.indiceUltimaPagina());
  }

  isPrimeiroAtivo() {
    return this.isAtivo(0);
  }

  ultimaPagina() {
    return this.paginas[this.indiceUltimaPagina()];
  }

  ativarSomente(indice) {
    this.desativarTodos();
    this.ativar(indice);
  }

  ativar(indice) {
    this.atual = indice + 1;
    return this.paginas[indice].active = true;
  }

  desativarTodos() {
    this.paginas = this.paginas.map((pagina) => {
      pagina.active = false; return pagina;
    });
  }

  mostrarPaginas() {
    const indiceAtual = this.indiceAtivo();
    return this.paginas.filter((el, indice) => {
      return (
        indice >= (indiceAtual - LIMITE_ITENS_ATUAL)
        && indice <= (indiceAtual + LIMITE_ITENS_ATUAL)
      );
    });
  }

  clickIrProximo(e) {
    e.preventDefault();
    this.irProximo();
  }

  irProximo() {
    if (!this.isUltimoAtivo()) {
      const novoIndice = this.indiceAtivo() + 1;
      this.ativarSomente(novoIndice);
      this.emitirCallback(this.paginas[novoIndice]);
    }
  }

  clickIrAnterior(e) {
    e.preventDefault();
    this.irAnterior();
  }

  irAnterior() {
    if (!this.isPrimeiroAtivo()) {
      const novoIndice = this.indiceAtivo() - 1;
      this.ativarSomente(novoIndice);
      this.emitirCallback(this.paginas[novoIndice]);
    }
  }

  navegar(pagina, event) {
    const indice = this.paginas.indexOf(pagina);

    if (event) {
      event.preventDefault();
    }

    this.ativarSomente(indice);
    this.emitirCallback(pagina);
  }

  emitirCallback(pagina) {
    if (this.callback) {
      this.callback.emit(pagina);
    }
  }
}
